var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "pdd-iframe",
      class: { isIPhoneX: _vm.$GY_platform.isIPhoneX },
    },
    [
      _vm.actUrl
        ? _c("iframe", {
            staticClass: "pdd-iframe-con",
            attrs: { src: _vm.actUrl, frameborder: "0" },
          })
        : _vm._e(),
      _c("div", { staticClass: "top-btn-wrap" }, [
        _c(
          "div",
          { staticClass: "myreward-btn", on: { click: _vm.myRewardOrder } },
          [_vm._v("我的奖励")]
        ),
      ]),
      _c("div", { staticClass: "share-btn-wrap" }, [
        _c(
          "div",
          { staticClass: "share-btn", on: { click: _vm.handleShare } },
          [_vm._v("分享给好友赚补贴")]
        ),
      ]),
      _c(
        "van-popup",
        {
          staticClass: "rule-pop",
          model: {
            value: _vm.rulePop,
            callback: function ($$v) {
              _vm.rulePop = $$v
            },
            expression: "rulePop",
          },
        },
        [
          _c("div", { staticClass: "pop-con" }, [
            _c("div", { staticClass: "scroll-wrap" }, [
              _c("p", [
                _c("span", { staticClass: "txt-bold" }, [_vm._v("活动时间：")]),
                _vm._v("6月07日12:00-8月31日23:59"),
              ]),
              _c("p", [
                _c("span", { staticClass: "txt-bold" }, [_vm._v("活动规则：")]),
                _c("br"),
                _vm._v(
                  "1、活动期间，用户在高佣联盟APP或高佣优选小程序推广补贴商品产生的有效订单，可获得佣金和每单额外补贴；"
                ),
              ]),
              _c("p", [
                _vm._v(
                  "2、若订单发生售后/退货/退款或其他可能导致订单佣金失效的情况，则该笔订单视为无效订单，相应补贴也将从预估补贴中扣除；"
                ),
              ]),
              _c("p", [
                _vm._v(
                  "3、订单明细及佣金收益在高佣联盟-我的-拼多多订单中查看；"
                ),
              ]),
              _c("p", [
                _vm._v(
                  "4、本活动页面仅展示预估补贴，每月最终补贴收益结算为次月30日24点前确认收货的有效订单，补贴将在次次月28日发放至高佣联盟账户余额，可申请提现；（举例：6月5日下单，需在7月30日前确认收货，补贴将于8月28日发放）；"
                ),
              ]),
              _c("p", [
                _vm._v(
                  "5、所产生的订单不能存在流量劫持、刷单等违规行为，一经发现将取消奖励资格。"
                ),
              ]),
              _c("p", [
                _vm._v(" 6、仅针对千万补贴精选商品："),
                _c("br"),
                _vm._v(" （1）秒杀商品："),
                _c("br"),
                _vm._v(
                  " 若为自购，则每个商品每个用户只补贴1单；超过1单后仍可购买，有佣金但无补贴；"
                ),
                _c("br"),
                _vm._v(
                  " 若为非自购，则每个商品每个用户补贴3单；超过3单后仍可购买，有佣金但无补贴。"
                ),
                _c("br"),
                _vm._v(" （2）每日11点上新商品："),
                _c("br"),
                _vm._v(
                  " 若为自购，则每个商品每个用户补贴3单，超过3单后仍可购买，有佣金但无补贴；"
                ),
                _c("br"),
                _vm._v(
                  " 若为非自购，则每个商品每个用户补贴10单，超过10单后仍可购买，有佣金但无补贴。"
                ),
                _c("br"),
                _vm._v(" PS：非自购：下单和推广者不是同一人。"),
                _c("br"),
              ]),
            ]),
          ]),
          _c("div", {
            staticClass: "close-btn",
            on: {
              click: function ($event) {
                _vm.rulePop = false
              },
            },
          }),
        ]
      ),
      _c("WeChatShare", {
        attrs: {
          show: _vm.shareShow,
          width: "25%",
          config: ["weChat", "friend", "saveImg", "copyLink"],
          shareParam: _vm.shareParam,
          popTitle: "分享到微信",
        },
        on: {
          "update:show": function ($event) {
            _vm.shareShow = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }